import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import * as authService from "../services/auth.service";
import { clearTenantOwnerCache } from "../services/tenantOwnerService";
import { useGlobalContext } from "./useGlobalContext";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => authService.getStoredToken());
  const [isAuthenticated, setIsAuthenticated] = useState(Boolean(token));
  const { resetGlobalState } = useGlobalContext();

  useEffect(() => {
    const storedToken = authService.getStoredToken();
    setToken(storedToken);
    setIsAuthenticated(Boolean(storedToken));
  }, []);

  const login = useCallback(async (credentials) => {
    const session = await authService.login(credentials);
    setToken(session.token);
    setIsAuthenticated(true);
    return session;
  }, []);

  const logout = useCallback(() => {
    authService.logout();
    clearTenantOwnerCache();
    resetGlobalState();
    setToken(null);
    setIsAuthenticated(false);
    window.location.href = "/login";
  }, [resetGlobalState]);

  const value = useMemo(() => ({
    token,
    isAuthenticated,
    login,
    logout,
  }), [isAuthenticated, login, logout, token]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuthContext = () => {
  const value = useContext(AuthContext);
  if (!value) throw new Error("useAuthContext debe usarse dentro de AuthProvider");
  return value;
};
